<div class="container">
  <div class="container-title">Comics</div>
  <div class="container-content">
    <div class="container-paragraph">There is Comics about CxNxD here. Check out about CxNxD!</div>
  </div>
</div>

<style>
  .container-content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
  }

  .container-paragraph {
    width: 55%;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 768px) {
    .container-paragraph {
      align-items: center;
      width: 100%;
    }
  }
</style>
